"use client";

import React from "react";
import { motion, AnimatePresence } from "framer-motion";

export interface WizardStepProps {
  step: number;
  children: React.ReactNode;
  className?: string;
}

export function WizardStep({ step, children, className = "" }: WizardStepProps) {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={step}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.3 }}
        className={`w-full ${className}`}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
